import {ADMINISTRACION_MENU} from './administracion.menu';
import {PRODUCTOS_MENU} from './productos.menu';
import {PROMOCIONES_MENU} from './promociones.menu';
import {SEGURIDAD_MENU} from './seguridad.menu';
import {DEVOLUCIONES_MENU} from './devoluciones.menu';
import {INVENTARIO_MENU} from './inventario.menu';
import {FOLIOS_MENU} from './folios.menu';
import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {REPORTES_MENU} from './reportes.menu';

export const APP_MENU: AppMenuItem[] = [
  ADMINISTRACION_MENU,
  PRODUCTOS_MENU,
  PROMOCIONES_MENU,
  SEGURIDAD_MENU,
  DEVOLUCIONES_MENU,
  INVENTARIO_MENU,
  FOLIOS_MENU,
  REPORTES_MENU
];
